import { CONFIG } from '../global-config';

const EXTERNAL_BASE_URLS = {
  ALVINE_APP: CONFIG.alvineBaseUrl,
  SMEDEX_WEBSITE: CONFIG.smedexWebsiteUrl,
} as const;

// TODO: Refactor together with the rest once it's merged
const GENERATED_PATH = '/alvine/gfx/generated';

// External links configuration
export const EXTERNAL_LINKS = {
  // Alvine App Links (Legacy Alvine System)
  app: {
    base: EXTERNAL_BASE_URLS.ALVINE_APP,
    home: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php`,
    settings: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.daten`,
    administration: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.auswahl_rolle`,
    administration_with_role: (adminRoleId: number) =>
      `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.administration&sxx_call%5B4514f6f2e3%5D%5Buid%5D=${adminRoleId}`,
    mediathek: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.mediathek`,
    meineLektionen: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.meine_lektionen`,
    bildungsnachweis: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.lektionen_uebersicht.logbuch.uebersicht`,
    news: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.welcome_intern_b2b.persoenliche_nachrichten`,
    aufgaben: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.welcome_intern_b2b.aufgaben`,
    termine: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.welcome_intern_b2b.persoenliche_termine`,
    foren: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.welcome_intern_b2b.forenliste`,
    merkzettel: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.lektionen_management`,
    tasksOverview: `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.administration.meine_aufgaben.pflicht_uebersicht`,
    questionEdit: (questionId: number, examinationId: number) =>
      `${EXTERNAL_BASE_URLS.ALVINE_APP}/index.php?sxx_page=smedex.de.intern.mysmedex.administration.meine_lektionen.fragenkatalog.frage_details&sxx_call[3f678a20ae][quid]=${questionId}&sxx_call[3f678a20ae][exid]=${examinationId}`,
  },

  // Smedex Website Links (Marketing/Public)
  website: {
    base: EXTERNAL_BASE_URLS.SMEDEX_WEBSITE,
    logout: `${EXTERNAL_BASE_URLS.SMEDEX_WEBSITE}/de/logout`,
    support: (lang: string = 'de') => `${EXTERNAL_BASE_URLS.SMEDEX_WEBSITE}/${lang}/support`,
    jobs: `${EXTERNAL_BASE_URLS.SMEDEX_WEBSITE}/de/ueber-uns`,
  },

  // Alvine Paths
  alvine: {
    profilePictureUrl: (userId: string) =>
      `${CONFIG.alvineBaseUrl}${GENERATED_PATH}/user/${userId}/image__40x40.jpg`,
  },
};
